import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../../core/service/base.service';
import {ConfigurationParameters} from './resource/configuration-parameters';

@Injectable()
export class ConfigurationParametersService extends BaseService<ConfigurationParameters> {

  serviceUrl(): string {
    return `/api/t/{tenant}/configuration-parameters`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }
}
